import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import Header from "../../components/Header";
import Loader from "../../components/Loader";
import ExploreMorePairs from "../../components/PairSection/explore-more-pair";
import { useFonts } from "../../hooks/useFonts";
import { regexSearch } from "../../utils";
//import SearchIcon from "./../../assets/images/search-icon.svg"


const Explore = () => {
  useFonts()
  const [showSidebar, setShowSidebar] = useState(false);
  const [searchInputValue, setsearchInputValue] = useState("")
  const [filteredPairs, setFilteredPairs] = useState([])
  const { fontPairs } = useSelector((state) => state.font);
  const { darkTheme } = useSelector((state) => state.theme)

  useEffect(() => {
    
    setFilteredPairs(fontPairs)
  },[fontPairs])

  useEffect(() => {
    if(!searchInputValue) return setFilteredPairs(fontPairs);
    setFilteredPairs(fontPairs?.filter((item) => regexSearch(item, searchInputValue)));
  }, [searchInputValue])

  return (
    <div className={`page-wrapper full-width ${darkTheme ? "showDarkMode" : ""}`}>
      <Header showBurgerMenu="showBurgerMenu" hideActionBar="hideActionBar" setShowSidebar={setShowSidebar} showSidebar={showSidebar} />
      <main className="main-content align-items-start">
        <div className="inner-page-container">
          <div className="page-head d-md-flex align-items-center justify-content-between">
            <h1>Explore all pairs.</h1>
            <div className="font-search-bar">
            <svg viewBox="0 0 16 16" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.47619 2.28571C5.36481 2.28571 4.29894 2.72721 3.51308 3.51308C2.72721 4.29894 2.28571 5.36481 2.28571 6.47619C2.28571 7.02649 2.3941 7.5714 2.6047 8.07982C2.81529 8.58823 3.12395 9.05018 3.51308 9.43931C3.9022 9.82843 4.36415 10.1371 4.87257 10.3477C5.38098 10.5583 5.92589 10.6667 6.47619 10.6667C7.02649 10.6667 7.57141 10.5583 8.07982 10.3477C8.58823 10.1371 9.05018 9.82843 9.43931 9.43931C9.82843 9.05018 10.1371 8.58823 10.3477 8.07982C10.5583 7.57141 10.6667 7.02649 10.6667 6.47619C10.6667 5.36481 10.2252 4.29894 9.43931 3.51308C8.65344 2.72721 7.58757 2.28571 6.47619 2.28571ZM1.89683 1.89683C3.11135 0.682311 4.7586 0 6.47619 0C8.19378 0 9.84103 0.682311 11.0555 1.89683C12.2701 3.11135 12.9524 4.7586 12.9524 6.47619C12.9524 7.32666 12.7849 8.16879 12.4594 8.95452C12.281 9.38536 12.0569 9.79461 11.7918 10.1756L15.6653 14.049C16.1116 14.4953 16.1116 15.219 15.6653 15.6653C15.219 16.1116 14.4953 16.1116 14.049 15.6653L10.1756 11.7918C9.79461 12.0569 9.38536 12.281 8.95452 12.4594C8.16879 12.7849 7.32666 12.9524 6.47619 12.9524C5.62573 12.9524 4.78359 12.7849 3.99786 12.4594C3.21213 12.134 2.4982 11.6569 1.89683 11.0555C1.29546 10.4542 0.81843 9.74025 0.492971 8.95452C0.167512 8.16879 0 7.32666 0 6.47619C0 4.7586 0.682311 3.11135 1.89683 1.89683Z"
              />
            </svg>
              <input type="search" className="form-control" placeholder="Search fonts by name" 
              onChange={(e) => setsearchInputValue(e.target.value)}/> 
            </div>
          </div>

          {fontPairs.length === 0 ? <div style={{ textAlign: "center"}}><Loader /></div> : 
          <div className="font-lists2 row">
            {
              filteredPairs.map((item, index) => <ExploreMorePairs item={item} key={index}/>)
            }
          </div>}
        </div>
      </main>
    </div>
  );
};

export default Explore;
